import { Instagram, Youtube, Linkedin, Phone, Mail, MapPin, Globe } from "lucide-react";
import { CONTACT, NAV_LINKS } from "../../data/content";
import { scrollToId } from "../../lib/scroll";

const FOOTER_SERVICES = [
    "Website Development",
    "Mobile Apps",
    "E-commerce",
    "Automation",
    "Digital Business Solutions",
];

const SOCIALS = [
    { icon: Instagram, label: "Instagram", testid: "social-instagram" },
    { icon: Youtube, label: "YouTube", testid: "social-youtube" },
    { icon: Linkedin, label: "LinkedIn", testid: "social-linkedin" },
];

export const Footer = () => (
    <footer data-testid="footer" className="border-t border-white/8 bg-[#05070B] pt-16 pb-8">
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
                <div>
                    <img
                        src="/assets/logo-full.png"
                        alt="Animexa Tech Solutions logo"
                        data-testid="footer-logo"
                        className="h-36 w-auto rounded-xl border border-white/10"
                    />
                    <p className="mt-5 text-sm text-slate-400 leading-relaxed">
                        Turning Ideas into Digital Reality.
                    </p>
                    <div className="mt-5 flex gap-3">
                        {SOCIALS.map((s) => (
                            <a
                                key={s.label}
                                data-testid={s.testid}
                                href="#"
                                aria-label={`${s.label} (link coming soon)`}
                                title="Link coming soon"
                                onClick={(e) => e.preventDefault()}
                                className="h-10 w-10 rounded-full border border-white/12 flex items-center justify-center text-slate-400 transition-all duration-300 hover:text-[#F5C518] hover:border-[#F5C518]/50"
                            >
                                <s.icon size={17} />
                            </a>
                        ))}
                    </div>
                </div>

                <nav aria-label="Footer quick links">
                    <p className="font-jbmono text-[11px] uppercase tracking-[0.25em] text-[#00E5FF] mb-5">
                        Quick Links
                    </p>
                    <ul className="space-y-2.5">
                        {NAV_LINKS.map((l) => (
                            <li key={l.id}>
                                <button
                                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                                    onClick={() => scrollToId(l.id)}
                                    className="text-sm text-slate-400 hover:text-white transition-colors duration-300"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <p className="font-jbmono text-[11px] uppercase tracking-[0.25em] text-[#00E5FF] mb-5">
                        Services
                    </p>
                    <ul className="space-y-2.5">
                        {FOOTER_SERVICES.map((s) => (
                            <li key={s}>
                                <button
                                    data-testid={`footer-service-${s.toLowerCase().replace(/\s+/g, "-")}`}
                                    onClick={() => scrollToId("#services")}
                                    className="text-sm text-slate-400 hover:text-white transition-colors duration-300"
                                >
                                    {s}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="font-jbmono text-[11px] uppercase tracking-[0.25em] text-[#00E5FF] mb-5">
                        Contact
                    </p>
                    <ul className="space-y-3.5 text-sm text-slate-400">
                        <li>
                            <a data-testid="footer-phone" href={CONTACT.phoneTel} className="flex items-center gap-2.5 hover:text-white transition-colors">
                                <Phone size={14} className="text-[#F5C518] shrink-0" />
                                {CONTACT.phoneDisplay}
                            </a>
                        </li>
                        <li>
                            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 hover:text-white transition-colors break-all">
                                <Mail size={14} className="text-[#F5C518] shrink-0" />
                                {CONTACT.email}
                            </a>
                        </li>
                        <li className="flex items-center gap-2.5" data-testid="footer-location">
                            <MapPin size={14} className="text-[#F5C518] shrink-0" />
                            {CONTACT.location}
                        </li>
                        <li>
                            <a data-testid="footer-website" href="https://animexa.in" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-white transition-colors">
                                <Globe size={14} className="text-[#F5C518] shrink-0" />
                                {CONTACT.website}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs text-slate-500" data-testid="footer-copyright">
                    © 2026 Animexa Tech Solutions. All rights reserved.
                </p>
                <p className="font-jbmono text-[10px] uppercase tracking-[0.25em] text-slate-600">
                    Create <span className="text-[#F5C518]/60">·</span> Automate{" "}
                    <span className="text-[#F5C518]/60">·</span> Grow
                </p>
            </div>
        </div>
    </footer>
);
